import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {onMounted,onUnmounted} from "vue"
import screenfull from 'screenfull'
import {useTabsStore} from "@/store/tabs"
import {useSystemStore} from "@/store/system"

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useTabsStore()
const systemStore = useSystemStore()


onMounted(() => {
 
  screenfull.on("change",changeFullscroll)
  systemStore.getPermissions()
}),

onUnmounted(()=>{
  screenfull.off("change",changeFullscroll)
})




function changeFullscroll(){
  store.is_fullScroll = screenfull.isFullscreen
}

const debounce = (fn:object, delay:number) => {
    let timer = null;
    return function () {
      let context = this;
      let args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    }
  }
  
  const _ResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
    constructor(callback:object) {
      callback = debounce(callback, 16);
      super(callback);
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})